var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnClipOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_1214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 1.79004H4.92968C4.27816 1.79004 3.75 2.3182 3.75 2.96972V17.6509C3.75 18.76 5.14163 19.2562 5.84329 18.3972L9.46139 13.9679C9.93341 13.3901 10.8166 13.3901 11.2886 13.9679L14.9067 18.3972C15.6084 19.2562 17 18.76 17 17.6509V2.96972C17 2.3182 16.4718 1.79004 15.8203 1.79004Z",
    fill: "#7B35D3",
    stroke: "#7B35D3",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_1214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClipOn);
export default __webpack_public_path__ + "static/media/icn_clipOn.10176b7d4ea707defb31964f270762e0.svg";
export { ForwardRef as ReactComponent };